import { Helmet } from "react-helmet-async";

interface PersonJsonLdProps {
    name?: string;
    jobTitle?: string;
    url?: string;
    sameAs?: string[];
}

export const PersonJsonLd = ({
    name = "Marhaf Chamie",
    jobTitle = "Lead AI Engineer",
    url = "https://marhaf-chamie.web.app",
    sameAs = ["https://linkedin.com/in/inmogr", "https://github.com/inmogr", "https://x.com/inmogr"],
}: PersonJsonLdProps = {}) => {
    const data = {
        "@context": "https://schema.org",
        "@type": "Person",
        name,
        jobTitle,
        url,
        sameAs,
        alumniOf: {
            "@type": "CollegeOrUniversity",
            name: "IIUM",
        },
        knowsAbout: [
            "Agentic AI",
            "Multi-Agent Systems",
            "Retrieval-Augmented Generation (RAG)",
            "Evaluation Frameworks",
            "Model Context Protocol (MCP)",
            "Human-in-the-Loop",
            "Software Engineering",
            "React",
            "React Native",
            "TypeScript",
            "Python",
            "Node.js",
            "Cloud Computing",
            "Fintech",
            "Healthcare Technology",
        ],
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};

interface ProjectJsonLdProps {
    name: string;
    description: string;
    url: string;
    datePublished?: string;
    creator?: string;
}

export const ProjectJsonLd = ({
    name,
    description,
    url,
    datePublished = new Date().toISOString().split("T")[0],
    creator = "Marhaf Chamie",
}: ProjectJsonLdProps) => {
    const data = {
        "@context": "https://schema.org",
        "@type": "CreativeWork",
        name,
        description,
        url,
        creator: {
            "@type": "Person",
            name: creator,
        },
        datePublished,
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};

interface BreadcrumbJsonLdProps {
    items: Array<{
        name: string;
        url: string;
    }>;
}

export const BreadcrumbJsonLd = ({ items }: BreadcrumbJsonLdProps) => {
    const data = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: item.name,
            item: item.url,
        })),
    };

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Helmet>
    );
};
